<template>
  <v-container fill-height class="text-center">
    <v-row>
      <v-col style="max-width: 600px" class="mx-auto">
        <v-img
          alt="Error 404"
          contain
          :src="require('@/assets/images/icons/exclamation_mark.png')"
          :height="150"
        />

        <p class="mt-5 font-weight-bold text-h5">
          Na stronie wystąpił błąd i nie może zostać poprawnie wyświetlona.
        </p>

        <div class="my-2">
          <v-btn color="warning" dark @click="reloadPage">
            Spróbuj ponownie załadować stronę
          </v-btn>
        </div>

        <p class="mt-5">
          Możesz też skontaktować się z naszym handlowcem lub Biurem Obsługi
          Klienta.
        </p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'Error500',
  props: {
    message: {
      type: String,
      default: function () {
        return 'Wystąpił problem'
      }
    }
    // lang: {
    //   type: String,
    //   default: "pl"
    // }
  },
  created() {
    this.$ssrContext && this.$ssrContext.res.status(404)
  },
  methods: {
    reloadPage() {
      location.reload()
    }
  }
}
</script>
